import {NotificationIcon as Bell} from '../icons/AppIcons';
import React,{useRef,useState} from 'react';
import {httpsCallable} from 'firebase/functions';
import {LoaderCircle} from 'lucide-react';
import {functions} from '../../Security/firebase-config';

// Reuse Calendar's attendance workflow without opening or saving the editor.
export default function OverviewParticipationRequest({event,person,zone,onSent}) {
  const sending=useRef(false);
  const [busy,setBusy]=useState(false),[error,setError]=useState('');
  const send=async click=>{
    click.stopPropagation();
    if(sending.current)return;
    sending.current=true;setBusy(true);setError('');
    try {
      const result=await httpsCallable(functions,'requestEventParticipation')({
        teamId:event.__teamId,eventId:event.eventId||event.id,targetUid:person.uid,
        instanceDate:event.repeat&&event.repeat!=='none'?event.instanceDate||null:null,
        eventTag:event.tag||'Event',eventStartUTC:event.startUTC,eventEndUTC:event.endUTC,
        timeZone:zone,note:event.note||'',participantUsernames:event.participants||[],
      });
      if(result.data?.ok!==true)throw new Error('The confirmation request could not be sent.');
      onSent(result.data.status||'pending');
    }catch(failure){setError(failure?.message||'The confirmation request could not be sent. Please try again.');}
    finally{sending.current=false;setBusy(false);}
  };
  return <>
    <button type="button" className="overview-participation-request" disabled={busy} aria-label={busy?`Sending availability confirmation request to ${person.name}`:`Request availability confirmation from ${person.name}`} title={busy?'Sending confirmation request…':`Ask ${person.name} to confirm availability for this event`} onClick={send}>
      {busy?<LoaderCircle size={12} aria-hidden="true"/>:<Bell size={12} aria-hidden="true"/>}
    </button>
    {error&&<span className="overview-participation-request__error" role="alert">{person.name}: {error}</span>}
  </>;
}
